import styled from "styled-components";
import ListIcon from "../../../assets/img/ContentViewFilter/list.svg";
import CardIcon from "../../../assets/img/ContentViewFilter/card.svg";
import ListIconActive from "../../../assets/img/ContentViewFilter/list-active-transparent.svg";
import CardIconActive from "../../../assets/img/ContentViewFilter/card-active-transparent.svg";

import { useState, useEffect } from "react";

const ToggleView = (props) => {
  const [activeTab, setActiveTab] = useState(props.isListView ? "list" : "card");
  const { onToggle } = props;

  const switchLayout = (cardType) => {
    setActiveTab(cardType);
    onToggle(cardType === "list");
  };

  useEffect(() => {
    const viewType = props.isListView ? "list" : "card";
    if (viewType !== activeTab) {
      setActiveTab(viewType);
    }
  }, [props.isListView]);

  return (
    <StyleWrapper id={"ToggleView"}>
      <div onClick={() => switchLayout("list")} className={`list-view ${activeTab === "list" ? "active" : ""}`}>
        {activeTab === "list" ? (
          <img src={ListIconActive} alt="card icon" className="qa-card-icon" />
        ) : (
          <img src={ListIcon} alt="card icon" className="qa-list-icon" />
        )}
      </div>
      <div onClick={() => switchLayout("card")} className={`card-view ${activeTab === "card" ? "active" : ""}`}>
        {activeTab === "card" ? (
          <img src={CardIconActive} alt="card icon" className="qa-card-icon-one" />
        ) : (
          <img src={CardIcon} alt="card icon" className="qa-list-icon-one" />
        )}
      </div>
    </StyleWrapper>
  );
};
export default ToggleView;

const StyleWrapper = styled.div`
cursor: pointer;
display: inline-block;
display: flex;
}
.card-view{
display: inline-block;
width: 52px;
border: solid 1px #DADADA;
height: 36px;
display: flex;
justify-content: center;
align-items: center;
background-color: #fff;
border-top-right-radius:8px;
border-bottom-right-radius:8px;
@media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
  min-width: 36px;
  width: 36px;
  height: 30px;
  border-top-right-radius:6px;
  border-bottom-right-radius:6px;
  img{
    width:18px;
  }
}
}
.list-view{
    display: inline-block;
    border: solid 1px #DADADA;
    width: 52px;
    height: 36px;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius:8px;
    border-bottom-left-radius:8px;
    @media all and (max-width:1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      min-width: 36px;
      width: 36px;
      height: 30px;
      border-top-left-radius:6px;
      border-bottom-left-radius:6px;
      img{
        width:18px;
      }
    }
}
.active{
    background-color: #DEF6E6;
}

`;
